import React from "react";
import ValidSvg from "../../../svg/ValidSvg.svg";
import NotValidSvg from "../../../svg/NotsureSvg.svg";
import InvaliSvg from "../../../svg/InvalidSvg.svg";
import ToxicSvg from "../../../svg/ToxicSvg.svg";

function ReactionIcons({onClick}) {
  return (
    <div>
      <span className="tooltiptext">
        <div className="reactions d-flex gap-5 fst-normal">
          <div className="d-flex flex-column justify-content-center align-items-center"  >
            <div
              className="forum_valid d-flex justify-content-center"
              style={{
                backgroundColor: "rgba(70, 204, 173, 1)",
                height: "30px",
                width: "50px",
                borderRadius:'5px'
              }}
              onClick={onClick}
            >
              <img src={ValidSvg} name='valid'  alt="" />
            </div>
            <p style={{ fontSize: "1rem" }} id="valid">Valid</p>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="forum_valid  d-flex justify-content-center"
              style={{
                backgroundColor: "rgba(236, 128, 128, 1)",
                height: "30px",
                width: "50px",
                borderRadius:'5px'
              }}
              onClick={onClick}
            >
              <img src={InvaliSvg} name='invalid' alt="" />
            </div>
            <p style={{ fontSize: "1rem" }}>Invalid</p>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="forum_valid bg-warning d-flex justify-content-center"
              style={{
                height: "30px",
                width: "50px",
                borderRadius:'5px'
              }}
              onClick={onClick}
            >
              <img src={NotValidSvg} name='Not sure' alt="" />
            </div>
            <p style={{ fontSize: "1rem" }}>NotSure</p>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div
              className="forum_valid  d-flex justify-content-center"
              style={{
                backgroundColor: "rgba(152, 120, 206, 1)",
                height: "30px",
                width: "50px",
                borderRadius:'5px'
              }}
              onClick={onClick}
            >
              <img src={ToxicSvg} alt="" name='toxic' />
            </div>
            <p style={{ fontSize: "1rem" }}>Toxic</p>
          </div>
        </div>
      </span>
    </div>
  );
}

export default ReactionIcons;
